<div class="grid-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt: dig at (x, y) — x cyan (across), y coral (up) -->
  <div class="prompt-bar">
    <span class="prompt-text">{{ currLang === 'ar' ? 'احفر عن الكنز عند' : 'Dig for treasure at' }}</span>
    <span class="pair">
      <span class="paren">(</span>
      <span class="cx">{{ round.tx }}</span>
      <span class="comma">,</span>
      <span class="cy">{{ round.ty }}</span>
      <span class="paren">)</span>
    </span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-treasure-grid-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-treasure-grid-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn dig-btn" [disabled]="resolving || !stage?.canDig" (click)="onDig()">
      {{ currLang === 'ar' ? 'احفر هنا!' : 'Dig here!' }}
      <span aria-hidden="true">⛏️</span>
    </button>
    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <span class="success-icon" aria-hidden="true">💎</span>
      <span class="success-eq">{{ (currLang === 'ar' ? 'كنز عند ' : 'Treasure at ') + '(' + round.tx + ', ' + round.ty + ')!' }}</span>
      <span class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</span>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
